import { createContext, useContext, type RefObject } from 'react';

export const BoardViewportContext = createContext<RefObject<HTMLElement | null> | null>(null);

export function useBoardViewportRef() {
  return useContext(BoardViewportContext);
}
